import React from "react";
import { IconMessage, IconMail, IconWebhook, IconArrowRight } from "@tabler/icons-react";
import "./TemplateTypeSelector.css";

const TemplateTypeSelector = ({ selectedType, onTypeSelect, availableTemplates = {} }) => {
  const templateTypes = [
    {
      id: "whatsapp",
      title: "WhatsApp",
      description: "Mensagens via WhatsApp",
      icon: IconMessage,
      gradient: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
      color: "#25D366",
      count: availableTemplates.whatsapp?.length || 0,
      disabled: !availableTemplates.whatsapp?.length
    },
    {
      id: "email",
      title: "E-mail",
      description: "Templates de email personalizados",
      icon: IconMail,
      gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
      color: "#3b82f6",
      count: availableTemplates.email?.length || 0,
      disabled: !availableTemplates.email?.length
    },
    {
      id: "webhook",
      title: "Webhook",
      description: "Integração com sistemas externos",
      icon: IconWebhook,
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      color: "#8b5cf6",
      count: availableTemplates.webhook?.length || 0,
      disabled: !availableTemplates.webhook?.length
    }
  ];

  const handleTypeSelect = (type) => {
    if (!type.disabled) {
      onTypeSelect(type.id);
    }
  };

  return (
    <div className="template-type-selector">
      <div className="template-type-selector__header">
        <h3 className="template-type-selector__title">Escolha o Tipo de Comunicação</h3>
        <p className="template-type-selector__subtitle">Selecione como deseja automatizar a comunicação com seus clientes</p>
      </div>

      <div className="template-type-selector__cards-container">
        {templateTypes.map((type) => {
          const IconComponent = type.icon;
          const isSelected = selectedType === type.id;
          
          return (
            <div
              key={type.id}
              className={`template-type-selector__card template-type-selector__card--${type.id} ${isSelected ? 'template-type-selector__card--selected' : ''} ${type.disabled ? 'template-type-selector__card--disabled' : ''}`}
              style={{
                '--selected-color': type.color,
                '--hover-color': type.color
              }}
              onClick={() => handleTypeSelect(type)}
            >
              <div className="template-type-selector__card-content">
                <div className="template-type-selector__card-header">
                  <div className={`template-type-selector__icon-container template-type-selector__icon-container--${type.disabled ? 'disabled' : type.id}`}>
                    <IconComponent size={24} color="white" />
                  </div>
                  
                  <div className="template-type-selector__card-info">
                    <h4 className={`template-type-selector__card-title ${type.disabled ? 'template-type-selector__card-title--disabled' : ''}`}>
                      {type.title}
                      {type.count > 0 && (
                        <span className={`template-type-selector__template-count template-type-selector__template-count--${type.id}`}>
                          {type.count} template{type.count !== 1 ? 's' : ''}
                        </span>
                      )}
                    </h4>
                    <p className={`template-type-selector__card-description ${type.disabled ? 'template-type-selector__card-description--disabled' : ''}`}>
                      {type.description}
                    </p>
                  </div>
                </div>
                
                <div className="template-type-selector__card-footer">
                  {type.disabled ? (
                    <span className="template-type-selector__disabled-text">Nenhum template disponível</span>
                  ) : (
                    <div className={`template-type-selector__arrow-container ${isSelected ? 'template-type-selector__arrow-container--selected' : ''}`}>
                      <IconArrowRight size={20} />
                    </div>
                  )}
                </div>
              </div>

              {isSelected && !type.disabled && (
                <div className={`template-type-selector__selected-indicator template-type-selector__selected-indicator--${type.id}`} />
              )}
            </div>
          );
        })}
      </div>

      {!availableTemplates.whatsapp?.length && !availableTemplates.email?.length && !availableTemplates.webhook?.length && (
        <div className="template-type-selector__empty-state">
          <div className="template-type-selector__empty-icon">📨</div>
          <h4 className="template-type-selector__empty-title">Nenhum Template Encontrado</h4>
          <p className="template-type-selector__empty-description">
            Você precisa criar templates antes de configurar automações.
            <br />
            Acesse o módulo de Templates para começar.
          </p>
        </div>
      )}
    </div>
  );
};


export default TemplateTypeSelector;